// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b8f0cb82","703":"409e7af9"}[chunkId] + ".chunk.js";
};